import script from "./VersionUpdateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VersionUpdateModal.vue?vue&type=script&setup=true&lang=js"

import "./VersionUpdateModal.vue?vue&type=style&index=0&id=0569ed89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0569ed89"]])

export default __exports__